import BreadCrumb from '@/modules/shared/components/bread-crumb/breadcrumb';
import { Component, Vue, Watch } from 'vue-property-decorator';
import WithRender from './app.html';
import UserService from '@/services/UserService';
import { Inject } from 'vue-di-container';


@WithRender
@Component({
  components: {
    BreadCrumb,
  },
  diProvide: [UserService],
})
export default class App extends Vue {
  @Inject(UserService)
  public userService!: UserService;

  public breadcrumbList: any = [];
  public showPageTitle: boolean = false;


  public async mounted() {
    this.onRouteChange();
    if (this.$route.meta && this.$route.meta.pageTitle) {
      this.showPageTitle = true;
    }

  }

  @Watch('$route')
  public onRouteChange(): any {
    this.breadcrumbList = [];
    if (this.$route.meta && this.$route.meta.breadcrumb) {
      this.breadcrumbList = this.$route.meta.breadcrumb;
    }
  }

  public routeTo() {
    // if (this.breadcrumbList[pRouteTo].link) {
    //   this.$router.push(this.breadcrumbList[pRouteTo].link);
    // }
  }



}
